import { Alert } from '@mui/material';
import React from 'react';
import XeroSso from '../XeroSso';

export default function LoggedOut() {
  return <XeroSso mode="sign-in" notice={<Alert severity="success">You've been signed out.</Alert>} />;
}
